module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "sigil_toc_id_3",
      "title": "Veritas Forum"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('em', [_vm._v("We create for the exploration of true life.")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('em', [_vm._v("We seek to inspire the shapers of tomorrow’s culture to connect their hardest questions with the person and story of Jesus Christ.")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("For hundreds of video and audio recordings of events like those presented in this volume, visit The Veritas Forum website: "), _c('a', {
    attrs: {
      "href": "http://www.veritas.org",
      "target": "_blank"
    }
  }, [_vm._v("www.veritas.org")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-745d62d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Veritas.vue
// module id = 72
// module chunks = 0